<div class="section-title section-title--cardgrading" title="Image contains stacks of SGC graded cards">
    <h2>Download Mobile App</h2>
</div>

<div class="mobile-row-wrapper">
    <div class="mobile-download-row">
        <div >
            <h2 class="sub-head">Enhance the way you collect</h2>
            <p class="description">
                Submit orders directly from the app and track the progress of your submissions as they go through the grading process.
                Build, manage and enjoy your collection with the My Cards feature. Use the Cert Verification feature to access high-resolution images and look up important information about your SGC cards.
                Search Pop Report data with ease. Download high-resolution images of cards that you submit for grading.
            </p>

            <div class="social-links-row">
                <div class="social-links">
                    <a href="https://apps.apple.com/app/id1625689449" target="_blank">
                        <img style="width: 203px;" src="/assets/img/blog/play_badges_apple.png" alt="">
                    </a>
                </div>
                <div class="social-links">
                    <a href="https://play.google.com/store/apps/details?id=com.sgcgrading" target="_blank">
                        <img style="width: 220px;" src="/assets/img/blog/play_badges_google.png" alt="">
                    </a>
                </div>
                <div class="social-links" style="cursor: default;"  >
                    <!-- <a  style="cursor: default;"  > -->
                        <img style="width: 130px; margin-left: 20px;cursor: default" src="/assets/img/blog/footerqrcode.png" >
                    <!-- </a> -->
                </div>
            </div>
        </div>
        <div >
            <div class="mobile-flex" style=" height:auto;width: 80%;">
                <div  >
                    <img style="width:99%;" src="/assets/img/blog/android-phone-left.png"  alt="">
                </div>
                <div >
                    <img style="width: 100%;" src="/assets/img/blog/iphone-right.png" alt="">
                </div>
            </div>
        </div>
        <!-- <div style="flex: 1;text-align: center;">
            <img style="width: 75%;" src="/assets/img/blog/iphone-right.png" alt="">
        </div> -->
    </div>
</div>
<div class="footer" style="padding-top: 28px;" >
    <div class="footer__container">
        <div class="footer__logo">
            <img src="/assets/img/SGC_White-New.png" class="image-set-mobile" title="SGC Logo" alt="SGC White Logo" style="margin-top: -15px; margin-left: -30px;">
        </div>
        <div class="footer__col">
            <h4 style="color:white;">Contact</h4>
            <div class="footer__address">
                <p>SGC</p>
                <p>951 W YAMATO RD STE 101</p>
                <p>BOCA RATON FL 33431</p>
                <ul class="footer__menu">
                    <li>
                        <a routerLink="/collector-support" class="footer__menu-item">CONTACT US</a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="footer__col">
            <h4 style="color:white;">Navigation</h4>
            <ul class="footer__menu">
                <!--<li><a routerLink="/culture" class="footer__menu-item">Culture</a></li>-->
                <li><a routerLink="/card-grading" class="footer__menu-item">Card Grading</a></li>
                <li><a routerLink="/pop-report" class="footer__menu-item">Pop report</a></li>
                <li><a routerLink="/cert-code-lookup" class="footer__menu-item">CERT VERIFICATION</a></li>
                <!--<li><a routerLink="/aboutus" class="footer__menu-item">About Us</a></li>-->
                <li><a routerLink="/collector-support" class="footer__menu-item">Collector Support</a></li>
                <li><a routerLink="/sgc-grading-app" class="footer__menu-item">Download App</a></li>
                <!--<li><a routerLink="/media" class="footer__menu-item">Media</a></li>
                <li><a routerLink="/old-homePage" class="footer__menu-item">Landing Page</a></li>
                <li><a routerLink="/original-homePage" class="footer__menu-item">Original</a></li>-->
                <!--<li><a routerLink="/revised-original" class="footer__menu-item">Revised Original</a></li>-->
            </ul>
        </div>
        <div class="footer__col">
            <h4 style="color:white;">My account</h4>
            <ul class="footer__menu">
                <li><a routerLink="/account/myorder" class="footer__menu-item">My Orders</a></li>
                <!-- <li><a routerLink="/" class="footer__menu-item">My reports</a></li> -->
                <li><a routerLink="/account" class="footer__menu-item">My profile</a></li>
                <li><a routerLink="/checkout" class="footer__menu-item">Start New Submission</a></li>
            </ul>
        </div>
        <div class="footer__col">
            <h4 style="color:white;">Download App</h4>
            <ul class="footer__menu"  style="cursor: pointer;">
                <img style="width: 100px; cursor: pointer;" routerLink="/sgc-grading-app" src="../../../../assets/img/blog/footerqrcode.png" alt="">
            </ul>
        </div>
        <div class="footer__col footer__col--right">
            <h4 class="icon-heading" style="color:white;margin-top: -30px; margin-right: 31px;
            ">Follow sgc grading</h4>
            <div class="followUsSocial_3" style="  position: relative;
            top: -33px; ;">
                    <a style="display:inline-block;padding-right:5px;"  href="https://www.instagram.com/sgcgrading" target="_blank"    >
                        <!-- Instagram Icon. -->
                        <img title=" Follow us on Instagram" src="/assets/img/InstagramIcon(inverted).png">
                    </a>
                <a style="display:inline-block;padding-right:5px;" href="https://www.facebook.com/sgcgrading" target="_blank">
                    <img title="Follow us on Facebook" src="/assets/img/FacebookIcon(inverted).png">
                </a>
                <a style="display:inline-block;padding-right:5px" href="https://twitter.com/sgcgrading" target="_blank">
                    <!-- thread Icon. -->
                    <img title="Follow us on X(Twitter)" src="/assets/img/thread.png">
                </a>
                <a style="display:inline-block; padding-right:5px" href="https://www.tiktok.com/@sgcgrading" target="_blank">
                    <!-- tiktok Icon -->
                    <img title=" Follow us on tiktok" src="/assets/img/tiktok_icon.png">
                </a>
                <a style="display:inline-block;padding-right:5px" href="https://youtube.com/@sgcgrading"  target="_blank">
                    <!-- thread Icon. -->
                    <img title="Follow us on Youtube" src="/assets/img/youtube_icon.png">
                </a>
            </div>
            <!-- <ul class="footer__social">
                <li><a href=""><img src="/assets/img/instagram.svg" alt="Instagram"></a></li>
                <li><a href=""><img src="/assets/img/facebook.svg" alt="Facebook"></a></li>
                <li><a href=""><img src="/assets/img/twitter.svg" alt="Twitter"></a></li>
                <li><a href=""><img src="/assets/img/youtube.svg" alt="YouTube"></a></li>
            </ul> -->
        </div>
        <div class="footer__copyright" style="display: flex; justify-content: space-between; " >
            <p>Copyright © 2025 SGC, LLC. All rights reserved.</p>
            <ul class="footer__menu" style="display: flex; gap: 30px;" >
                <li><a routerLink="/terms" class="footer__menu-item">Terms & conditions</a></li>
                <li><a routerLink="/privacy" class="footer__menu-item">Privacy Policy</a></li>
            </ul>
        </div>
    </div>
</div>


<!-- <div class="content--compact" style="padding-top: 10px;background-color:#252525;">
    <div class="about-img"><img _ngcontent-c3="" class="news__image" src="/assets/img/blog/cardfan.png" style="width:100%;"></div>
    <div class="about-sec">
        <h2>About us</h2>
        <p style="font-family:'d35';font-size:25px; line-height:30px;font-weight: normal;padding-top:30px;padding-right:20px;margin-bottom:12px;">
            Since 1998, SGC has been a well-established leader in the authentication and grading of trading cards. Our ability to provide accurate and consistent grades in a timely manner is a service that is unique to the card-collecting community and has made SGC one of the pillars of card grading for over 24 years. As our team continues to grow and our footprint continues to expand, our mission remains the same — to help build a better hobby for all collectors.
        </p>
    </div>
</div>

<h2 style="color:#ffffff;text-align:center;background-color:#252525;padding-top:100px; float:left; width:100%; margin-bottom:3px;">NEWS</h2>
<section class="services pd-top revised-services">

    <div class="services__item" style="padding:1.5%;">
        <div class="services__item-title">
            <img alt="Scott Hileman bio" src="/assets/img/blog/ScottArticle.jpg" style="width: 100%;">
        </div>
        <p style="color:#ffffff;font-size:19px; line-height:26px;font-weight: normal;">
            The SGC brand has come a long way. Learn more about the man who helped make it all possible.
            <a routerLink="/scott-Article" class="more">Read More</a>
        </p>
    </div>

    <div class="services__item" style="padding:1.5%;">
        <div class="services__item-title">
            <img alt="Free Autogrades" src="/assets/img/blog/free-autogrades.jpg" style="width: 100%;">
        </div>
        <p style="color:#ffffff;font-size:19px; line-height:26px;font-weight: normal;">
            At SGC, we believe you should not have to pay to have your pack-pulled autographs graded. Find out more about our stance on this very impactful service.
            <a routerLink="/free-autogrades" class="more">Read More</a>
        </p>
    </div>
    <div class="services__item" style="padding:1.5%;">
        <div class="services__item-title">
            <img alt="No Upcharge On Modern" src="/assets/img/blog/no-upcharge-modern.jpg" style="width: 100%;">
        </div>
        <p style="color:#ffffff;font-size:19px; line-height:26px;font-weight: normal;">
            Don’t pay unnecessary upcharges to have your modern cards graded. At SGC, what you pay upfront for modern card grading, is all you will pay regardless of your cards’ value.
            <a routerLink="/no-upcharge-modern" class="more">Read More</a>
        </p>
    </div>

</section>



<div class="container_2" style="background:#252525;">
    <h2 style="color:#ffffff;margin-bottom:-20px; float:left; text-align:center;width:100%;">Recent Posts</h2>
    <iframe scrolling="no" src="https://widget.taggbox.com/76864" style="width:100%;min-height: 800px;border:none;margin-top: -100px;"></iframe>
</div>

<div style="margin-top:-73px;"></div> -->
